'use client';

import { useEffect } from 'react';
import { useTranslations } from 'next-intl';
import { trackEvent } from 'components/shared/UserAnalytics/funnelEvents';
import { ZapIcon } from 'components/ring-air/ZapIcon';
import { AE_DELIVERY_GTM_EVENTS } from './config';
import { useAeDeliveryWindow } from './useAeDeliveryWindow';
import { aeDeliveryEtaInlineCopy } from './copy';
import styles from './index.module.css';

/**
 * UAE delivery-promise card for /ae/ring/buy. Visually mirrors India's
 * DeliveryEtaBadge card (same grey chrome, zap mark, title typography) but
 * drops the pincode input and Check CTA — AE delivery is a flat promise
 * across the whole of Dubai and Abu Dhabi, not pincode-checked. The title is
 * the full composed copy ("Arrives in 4 hours across Dubai and Abu Dhabi")
 * so this is the only ETA element in the hero SddDeliverySlot — no separate
 * meta line, no slim line stacked above it. The zap icon is the exact same
 * component (size + lottie intro + reduced-motion handling) as India's
 * DeliveryEtaBadge, passed a constant playToken since this card never
 * changes state post-mount (only the one-time intro plays).
 */
export const AeDeliveryEtaCard = () => {
  const t = useTranslations('ring');
  const deliveryWindow = useAeDeliveryWindow(true);

  useEffect(() => {
    // Fire once per mount, not once per `deliveryWindow` change — a visitor
    // who keeps the tab open across a window boundary shouldn't re-fire the
    // "shown" event. Reads `deliveryWindow` from the closure deliberately
    // instead of adding it to the deps array.
    trackEvent(AE_DELIVERY_GTM_EVENTS.SHOWN, { deliveryWindow });
  }, []);

  return (
    <div className={styles.badge}>
      <div className={styles.card}>
        <div className={styles.titleRow}>
          <ZapIcon playToken={0} />
          <p className={styles.title}>
            <strong>{aeDeliveryEtaInlineCopy(deliveryWindow, t)}</strong>
          </p>
        </div>
      </div>
    </div>
  );
};
